import React, { FC, memo, ReactNode, useState } from 'react';
import { useMutation } from 'react-query';
import { BusinessPartnersAPI } from 'api/BusinessPartnersAPI';
import { DownloadOutlined } from '@ant-design/icons/lib';
import { Button, message, Modal, Tooltip } from 'antd';
import { ButtonProps } from 'antd/lib/button';
import { useFormatMessage } from 'common/hooks/useFormatMessage';
import { BusinessPartner } from 'models/businessPartner';
import FileSaver from 'file-saver';
import { Checkbox } from 'antd';

export interface BusinessPartnerIntegrationButtonProps
  extends Omit<ButtonProps, 'onClick' | 'loading' | 'href'> {
  businessPartner: BusinessPartner;
  tooltip?: ReactNode;
}

export const BusinessPartnerIntegrationCreateButton: FC<BusinessPartnerIntegrationButtonProps> = memo(
  ({ businessPartner, tooltip, ...buttonProps }) => {
    const [mutate, { isLoading }] = useMutation(
      BusinessPartnersAPI.createPartnerIntegrationAccount
    );
    const intlMessage = useFormatMessage();

    const [sdkClientChecked, setSdkClientChecked] = useState(false);

    const confirm = () => {
      Modal.confirm({
        title: `Do you want to create integration account and download credentials for ${businessPartner.name}?`,
        icon: <DownloadOutlined />,
        okText: intlMessage({ id: 'yes' }),
        cancelText: intlMessage({ id: 'cancel' }),
        okType: 'primary',
        onOk: () =>
          mutate(
            {
              businessPartnerId: businessPartner.id,
              sdkClient: sdkClientChecked,
            },

            {
              onSuccess: (res) => {
                const blob = new Blob([res.data], {
                  type: 'text/plain;charset=utf-8',
                });

                FileSaver.saveAs(blob, 'partner_integration_data.txt');
                message.success(
                  `Integration user account for ${businessPartner.name} has been created.`
                );
              },
            }
          ),
      });
    };

    const button = (
      <>
        <div style={{ width: '100%', marginBottom: '15px' }}>
          <Checkbox
            key="denyAccess"
            onChange={(e) => {
              setSdkClientChecked &&
                e.target.checked &&
                setSdkClientChecked(true);
            }}
          />
          <span style={{ marginLeft: '7px' }}> SDK client</span>
        </div>
        <Button
          loading={isLoading}
          download="test.csv"
          type="primary"
          onClick={() => confirm()}
          icon={<DownloadOutlined />}
          {...buttonProps}
        >
          API Credentials
        </Button>
      </>
    );

    return tooltip ? <Tooltip title={tooltip}>{button}</Tooltip> : button;
  }
);
